import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Component, forwardRef, Inject, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {EmployeeForScheduling, EmployeeSchedule} from '../../model/schedule.model';
import * as moment from 'moment';
import {SessionService} from "../../services/session.service";
import {ClientService} from "../../services/client.service";
import {AlertService} from "../../services/alert.service";
import {DayType, ModalResult} from "../../model/common.model";
import {DisplayInterval} from "../../directives/displayInterval";
import {WeeklyWorkShift} from "./model/WeeklyWorkShift";
import {Utils} from "../../model/Utils";
import {DateEncoding} from "../../model/DateEncoding";
import {IntervalAndDelay} from "../../model/IntervalAndDelay";


@Component({
  // selector: 'ngbd-modal-content',
  templateUrl: 'DlgEmployeeScheduleComponent.html'
})
export class DlgEmployeeScheduleComponent {

  @Input() employeeForSchedulings: EmployeeForScheduling[];


  // private toRemoves: string[];
  // private selectedRowIndex = new Map<number, boolean>();
  // private selectedRowIndex = new Map<string, boolean>();
  private allCheckboxes = new Array<EmployeeScheduleSelection>();
  private checkBoxesByEmployee = new Map<string, EmployeeScheduleSelection[]>();
  private checkBoxesByDayType = new Map<string, EmployeeScheduleSelection[]>();
  private checkBoxesByEmployeeByDayType = new Map<string, Map<string, EmployeeScheduleSelection>>();


  private message: any;


  private displayInterval;
  weeklyWorkShift: WeeklyWorkShift;
  weeklyWorkShiftInterval: number;
  weeklyWorkShiftIntervalOvernight: number;
  weeklyWorkShiftIntervalAndDelay: IntervalAndDelay;
  weeklyWorkShiftIntervalAndDelayOvernight: IntervalAndDelay;

  alreadyScheduled: EmployeeSchedule[];
  dayVisible: boolean[] = new Array(7);

  visibleDays = new Array<number>();

  private _visibleDayTypes = new Array<DayType>();


  nbEmployeePlanned: string[] = new Array(7);
  @Input() dayLabel: string[] = new Array(7);
  // @Input() refDates: Date[] = new Array<Date>();

  private unavailabilitiesPerEmployeeIdDayType = new Map<String,any>();

  constructor (
    @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
    @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
    public activeModal: NgbActiveModal,
    // private router: Router,
    @Inject(forwardRef(() => SessionService)) private session: SessionService,
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService
  ) {

    this.displayInterval = new DisplayInterval(session);
    this._prepareDayLabels();
    // this._retrieveRefDates();

  }
  private _prepareDayLabels() {
    // this.dayLabel = this.session.userInfo.prepareDayLabels()
    this.dayLabel = this.session.userInfo.prepareShortDayLabels();
  }

  private _createKey(dayType: DayType, employeeId: string): string{
    return employeeId + "." + dayType.toString();
  }

  canSeeAmount():boolean{
    return this.session.canSeeAmount();
  }


  /*
  private _retrieveDayTypeFromKey(key: string): DayType{
    if (key.lastIndexOf('.')>0){
      const code = key.substr(key.lastIndexOf('.') + 1);
      return DayType.retrieveFromCode(code);
    }
    return null;
  }

  private _retrieveEmployeeCode(key: string): string{
    if (key.lastIndexOf('.')>0){
      return key.substring(0,key.lastIndexOf('.'));
    }
    return null;
  }
  */



  private _prepareEmployeeUnavailabilities(){
    if (!this.employeeForSchedulings){
      return;
    }
    for (const bean of this.employeeForSchedulings){

      let key = this._createKey(DayType.SUNDAY,bean.employee.id);
      this.unavailabilitiesPerEmployeeIdDayType.set(key, this._dayUnAvailability(DayType.SUNDAY,bean));
      key = this._createKey(DayType.MONDAY,bean.employee.id);
      this.unavailabilitiesPerEmployeeIdDayType.set(key, this._dayUnAvailability(DayType.MONDAY,bean));
      key = this._createKey(DayType.TUESDAY,bean.employee.id);
      this.unavailabilitiesPerEmployeeIdDayType.set(key, this._dayUnAvailability(DayType.TUESDAY,bean));
      key = this._createKey(DayType.WEDNESDAY,bean.employee.id);
      this.unavailabilitiesPerEmployeeIdDayType.set(key, this._dayUnAvailability(DayType.WEDNESDAY,bean));
      key = this._createKey(DayType.THURSDAY,bean.employee.id);
      this.unavailabilitiesPerEmployeeIdDayType.set(key, this._dayUnAvailability(DayType.THURSDAY,bean));
      key = this._createKey(DayType.FRIDAY,bean.employee.id);
      this.unavailabilitiesPerEmployeeIdDayType.set(key, this._dayUnAvailability(DayType.FRIDAY,bean));
      key = this._createKey(DayType.SATURDAY,bean.employee.id);
      this.unavailabilitiesPerEmployeeIdDayType.set(key, this._dayUnAvailability(DayType.SATURDAY,bean));

    }
  }

  private _dayUnAvailability(dt: DayType, bean: EmployeeForScheduling): string{

    // console.log('bean: ',bean);
    const avail = bean.availabilityPerDayType(dt);
    // console.log('avail: ',avail);
    //console.log('No Availability: ' + avail.hoursNotAvailable.length);
    let res = '';
    for (let idx = 0; idx < avail.hoursNotAvailable.length-1; idx+=2){
      const start = avail.hoursNotAvailable[idx];
      const end = avail.hoursNotAvailable[idx+1];
      if (res.length>0){
        res += ', ';
      }
      res += this.displayInterval.displayDates(start,end,this.displayInterval.formatAMPM);
    }
    return res;
    // = moment().day(dayIndex + idx).format('dddd');
  }


  hasDayUnavailability(idx: number, employeeId: string): boolean{
    let dayIndex = this.session.userInfo.weekStart.momentCode;
    const dt = DayType.retrieveFromMomentCode(moment().day(dayIndex + idx).day());
    const key = this._createKey(dt, employeeId);
    if (this.unavailabilitiesPerEmployeeIdDayType.get(key)){
      if (this.unavailabilitiesPerEmployeeIdDayType.get(key).length>0){
        return true;
      }
    }
    return false;
  }

  getDayUnavailability(idx: number, employeeId: string): string{
    let dayIndex = this.session.userInfo.weekStart.momentCode;
    const dt = DayType.retrieveFromMomentCode(moment().day(dayIndex + idx).day());
    const key = this._createKey(dt, employeeId);
    if (this.unavailabilitiesPerEmployeeIdDayType.get(key)){
      return this.unavailabilitiesPerEmployeeIdDayType.get(key);
    }
    return 'N/A';
  }

  /*
  _dayUnAvailability(idx: number, bean: EmployeeForScheduling): string{
    let dayIndex = this.session.userInfo.weekStart.momentCode;
     const dt = DayType.retrieveFromMomentCode(moment().day(dayIndex + idx).day());
     console.log('DayAvailability for ' + bean.employee.fullName + ' ' + dt.toString());

     const avail = bean.availabilityPerDayType(dt);

    console.log('No Availability: ' + avail.hoursNotAvailable.length);
     let res = '';
     for (let idx = 0; idx < avail.hoursNotAvailable.length-1; idx+=2){
       const start = avail.hoursNotAvailable[idx];
       const end = avail.hoursNotAvailable[idx+1];
       if (res.length>0){
         res += ', ';
       }
       res += this.displayInterval.displayDates(start,end,this.displayInterval.formatAMPM);
     }
     return res;
     // = moment().day(dayIndex + idx).format('dddd');
  }
  */

  public _isAfterToday(refDt: Date) {
    return Utils.isAfterToday(refDt);
  }


  private _prepareIntervals(){
    const de = new DateEncoding();
    const res = de.encodeWithOvernightCheckOnDates(this.weeklyWorkShift.startTime,this.weeklyWorkShift.endTime);
    this.weeklyWorkShiftInterval = res.interval;
    this.weeklyWorkShiftIntervalOvernight = res.intervalOverNight;
    this.weeklyWorkShiftIntervalAndDelay = IntervalAndDelay.create(res.interval);
    this.weeklyWorkShiftIntervalAndDelayOvernight = IntervalAndDelay.create(res.intervalOverNight);
  }

  /**
   *
   * @param {EmployeeForScheduling[]} contains employee retrieved from the system with the same job and theirs availabilities
   * @param {string[]} employeeAlreadyScheduledInDifferentJobOrShiftOrBoth
   * @param {WeeklyWorkShift} model
   */
  populate(beans: EmployeeForScheduling[], model: WeeklyWorkShift, employeeAlreadyScheduledInDifferentJobOrShiftOrBoth: EmployeeSchedule[]){
    this.employeeForSchedulings = beans;

    this.alreadyScheduled = employeeAlreadyScheduledInDifferentJobOrShiftOrBoth;

    this.weeklyWorkShift = model;


    this._prepareIntervals();


    this._hideInvisibleDays();
    this._prepareEmployeeUnavailabilities();
    this._prepareAndPopulateCheckBoxes();
    // validate the checkboxes if employee is schedules.

    if (model.planned){
      let weekNbr = this.session.userInfo.weekStart.momentCode;
      for (let idx = 0 ; idx < this.dayLabel.length; idx++) {
        const dt = DayType.retrieveFromMomentCode(moment().day(weekNbr).day());
        this.nbEmployeePlanned[idx] = model.getExpectedQuantityPlannedByDay(dt) + '';
        // this.dayLabel[idx] = moment().day(weekNbr).format('dddd');
        weekNbr++;
      }
    }

  }

  public messageId(idx: any,nbr: any): string{
    return idx + '.' + nbr;
  }

  private _hideInvisibleDays(){
    // Hides not needed days.
    // let weekNbr = this.session.userInfo.weekStart.momentCode;
    let idx = 0; // Working because the refDates are in the right order too... (aka with weekStart)
    for (const refDt of this.weeklyWorkShift.refDates){
      if (this._isAfterToday(refDt)){
        // const dt = DayType.retrieveFromDate(refDt);
        this.dayVisible[idx]=true;
        this.visibleDays.push(idx);
        this._visibleDayTypes.push(DayType.retrieveFromDate(refDt));
      }else{
        this.dayVisible[idx]=false;
      }
      idx++;
    }


  }

  private _prepareAndPopulateCheckBoxes(){
    // Preparing selections
    for (const bean of this.employeeForSchedulings){
      for (const dayType of this._visibleDayTypes){
      /*
      for (let idx=0; idx<7; idx++){
        if (this.dayVisible[idx]===false){
          // if day is not visible...
          continue ;
        }
        */
        const selection = new EmployeeScheduleSelection();
        selection.employeeId = bean.employee.id;
        selection.value = false;
        // selection.dayType = DayType.retrieveFromMomentCode(idx);
        selection.dayType = dayType;
        selection.data = bean;
        if (!this.checkBoxesByDayType.get(selection.dayType.code)){
          this.checkBoxesByDayType.set(selection.dayType.code,new Array<EmployeeScheduleSelection>());
        }
        if (!this.checkBoxesByEmployee.get(selection.employeeId)){
          this.checkBoxesByEmployee.set(selection.employeeId,new Array<EmployeeScheduleSelection>());
        }
        this.checkBoxesByDayType.get(selection.dayType.code).push(selection);
        this.checkBoxesByEmployee.get(selection.employeeId).push(selection);
        this.allCheckboxes.push(selection);

        if (!this.checkBoxesByEmployeeByDayType.get(selection.employeeId)){
          this.checkBoxesByEmployeeByDayType.set(selection.employeeId, new Map<string,EmployeeScheduleSelection>());
        }
        this.checkBoxesByEmployeeByDayType.get(selection.employeeId).set(selection.dayType.code,selection);

        // Checked if Not already in the schedule.
        if (this.weeklyWorkShift){
          for (const bean of this.weeklyWorkShift.schedulesByDay(selection.dayType)){
            // Sanity Check!
            if (this.checkBoxesByEmployeeByDayType.get(bean.employee.id)){
              // console.log('Prepare&Populate Setting ' + bean.employee.fullName + ' ' + selection.dayType + ' to true');
              this.checkBoxesByEmployeeByDayType.get(bean.employee.id).get(selection.dayType.code).value = true;
            }
          }
        }

      }
    }

  }


  /*
  isAvailable(row: number): boolean {
     const bean = this.employeeForSchedulings[row];
     if (bean){
       for (const id of this.toRemoves){
         if (id===bean.employee.id){
           return false;
         }
       }
     }
     return true;
  }
*/

  /*
  isSelectedRow(row: number): boolean{
     return this.selectedRowIndex.get(row);
  }
  */
  /**
   * Verify if the employee is not already scheduled in another weeklyWorkshift
   */
  isAvailable(row: number, employeeForScheduling: EmployeeForScheduling): boolean{
    let dayIndex = this.session.userInfo.weekStart.momentCode;
    const dt = DayType.retrieveFromMomentCode(moment().day(dayIndex + row).day());
    // console.log('Checking up for ' + dt);
    const de = new DateEncoding();
    for (const bean of this.alreadyScheduled){
      if (bean.employee.id === employeeForScheduling.employee.id){
        const refDt = DayType.retrieveFromDate(bean.refDate);
        // console.log('Checking up with ' + refDt);
        if (dt === refDt){

          const already = de.encodeWithOvernightCheckOnDates( bean.startHour,bean.endHour);
          const alreadyIntervalAndDelay = IntervalAndDelay.create(already.interval);
          const alreadyIntervalAndDelayOvernight = IntervalAndDelay.create(already.intervalOverNight);

          if (alreadyIntervalAndDelay.intersects(this.weeklyWorkShiftIntervalAndDelay)){
//            console.log(' Employee ' + bean.employee.fullName + ' has already a shift scheduled ' + bean.refDate + ' ' + alreadyIntervalAndDelay.formatAsDate(de));
            return false;
          }
          if (alreadyIntervalAndDelayOvernight.intersects(this.weeklyWorkShiftIntervalAndDelay)){
//            console.log(' Employee ' + bean.employee.fullName + ' has already a shift scheduled ' + bean.refDate + ' ' + alreadyIntervalAndDelayOvernight.formatAsDate(de));
            return false;
          }
          if (alreadyIntervalAndDelay.intersects(this.weeklyWorkShiftIntervalAndDelayOvernight)){
//            console.log(' Employee ' + bean.employee.fullName + ' has already a shift scheduled ' + bean.refDate + ' ' + alreadyIntervalAndDelay.formatAsDate(de));
            return false;
          }
          if (alreadyIntervalAndDelayOvernight.intersects(this.weeklyWorkShiftIntervalAndDelayOvernight)){
//            console.log(' Employee ' + bean.employee.fullName + ' has already a shift scheduled ' + bean.refDate + ' ' + alreadyIntervalAndDelayOvernight.formatAsDate(de));
            return false;
          }

          // has already a schedule for the same day for another job/shift.
          // console.log(' Employee ' + bean.employee.fullName + ' has already a shift scheduled ' + bean.refDate + ' ');
          // return false;
        }
      }
    }
    return true;
  }

  private _isFound(toFind:string, lst: string[]): boolean{
    let found = false;
    for (const m of lst){
      if (m === toFind){
        found = true;
        break;
      }
    }
    return found;
  }

  private _explainNotAvailable(dates: Date[], msgs: string[], bean: EmployeeSchedule){
    if (dates.length>0){
      let msg = '';
      if (dates.length==2){
        msg = this.translate.instant('EmployeeHasAlreadyAShiftHours',{fullName: bean.employee.fullName, startDate: this.session.formatDateAsHour(dates[0]), endDate: this.session.formatDateAsHour(dates[1])});
      }else{
        msg = this.translate.instant('EmployeeHasAlreadyAShift',{fullName: bean.employee.fullName, refDate: moment(bean.refDate).format('LL')});
      }
      if (!this._isFound(msg,msgs)){
        msgs.push(msg);
      }
    }

  }

  explainNotAvailable(row: number, employeeForScheduling: EmployeeForScheduling): string{
    let dayIndex = this.session.userInfo.weekStart.momentCode;
    const dt = DayType.retrieveFromMomentCode(moment().day(dayIndex + row).day());
    const msgs = new Array<string>();
    const de = new DateEncoding();
    // console.log('Checking up for ' + dt);
    for (const bean of this.alreadyScheduled){
      if (bean.employee.id === employeeForScheduling.employee.id){

        const refDt = DayType.retrieveFromDate(bean.refDate);
        // console.log('Checking up with ' + refDt);
        if (dt === refDt){

          const already = de.encodeWithOvernightCheckOnDates( bean.startHour,bean.endHour);
          const alreadyIntervalAndDelay = IntervalAndDelay.create(already.interval);
          const alreadyIntervalAndDelayOvernight = IntervalAndDelay.create(already.intervalOverNight);

          if (alreadyIntervalAndDelay.intersects(this.weeklyWorkShiftIntervalAndDelay)){
            const dates = alreadyIntervalAndDelay.formatAsDate(de);
            this._explainNotAvailable(dates,msgs,bean);
          }
          if (alreadyIntervalAndDelayOvernight.intersects(this.weeklyWorkShiftIntervalAndDelay)){
            const dates = alreadyIntervalAndDelayOvernight.formatAsDate(de);
            this._explainNotAvailable(dates,msgs,bean);
          }
          if (alreadyIntervalAndDelay.intersects(this.weeklyWorkShiftIntervalAndDelayOvernight)){
            const dates = alreadyIntervalAndDelay.formatAsDate(de);
            this._explainNotAvailable(dates,msgs,bean);
          }
          if (alreadyIntervalAndDelayOvernight.intersects(this.weeklyWorkShiftIntervalAndDelayOvernight)){
            const dates = alreadyIntervalAndDelayOvernight.formatAsDate(de);
            this._explainNotAvailable(dates,msgs,bean);
          }
          // const msg = this.translate.instant('EmployeeHasAlreadyAShift',{fullName: bean.employee.fullName, refDate: moment(bean.refDate).format('LL')});



          //
          // let found = false;
          // for (const m of msgs){
          //   if (m === msg){
          //      found = true;
          //      break;
          //   }
          // }
          // if (!this._isFound(msg,msgs)){
          //   msgs.push(msg);
          // }
        }
      }
    }
    let msg = '';
    for (const m of msgs){
      if (msg.length>0){
        msg += ", ";
      }
      msg += m;
    }


    return msg;
  }


  isSelectedRow(idx: number, bean: EmployeeForScheduling): boolean{
    let dayIndex = this.session.userInfo.weekStart.momentCode;
    const dt = DayType.retrieveFromMomentCode(moment().day(dayIndex + idx).day());
    if (this.checkBoxesByEmployeeByDayType.get(bean.employee.id).has(dt.code)){
      if (true === this.checkBoxesByEmployeeByDayType.get(bean.employee.id).get(dt.code).value){
        // console.log('isSelectedRow dt: ' + dt.toString() + ' idx: ' + idx + ' returning true...');
        return true;
      }
    }
    return false;
  }

  /**
   * When clicking on the checkbox, we verifies if one can be selected.
   *
   * if no planning or planning with qty=1 then selection is done/undone if done then others selection (same day) will be undone
   * If a planning with more than 1 then if too many selections then nothing is done/undone and a message is displayed.
   */
  onSelectRow(row: number, bean: EmployeeForScheduling): boolean {
    console.log('selectedRow: ' + row);

    let dayIndex = this.session.userInfo.weekStart.momentCode;
    const dt = DayType.retrieveFromMomentCode(moment().day(dayIndex + row).day());
    console.log('dayIndex: ' + dayIndex, dt);
    // const key = this._createKey(dt,bean.employee.id);
    let res: boolean;
    let nbPlanned = 1;
    if (this.weeklyWorkShift.planned){
      nbPlanned = this.weeklyWorkShift.getExpectedQuantityPlannedByDay(dt);
    }
    if (nbPlanned==0) {
      // console.log('Before: ' + JSON.stringify(this.checkBoxesByEmployeeByDayType,null,2));
      if (this.checkBoxesByEmployeeByDayType.get(bean.employee.id).get(dt.code).value === true) {
        this.alertService.clear();
        res = false;
      } else {
        this.alertService.warning(this.translate.instant('NoSchedulePlannedForThisDay'));
        res = true;
      }
      this.checkBoxesByEmployeeByDayType.get(bean.employee.id).get(dt.code).value = res;
    }
    if (nbPlanned==1) {
      // console.log('Before: ' + JSON.stringify(this.checkBoxesByEmployeeByDayType,null,2));
      if (this.checkBoxesByEmployeeByDayType.get(bean.employee.id).get(dt.code).value === true) {
        res = false;
      } else {
        res = true;
      }
      for (const selection of Array.from(this.checkBoxesByDayType.get(dt.code))) {
        selection.value = false;
      }
      this.checkBoxesByEmployeeByDayType.get(bean.employee.id).get(dt.code).value = res;
    }
    if (nbPlanned>1){
      let nbSelected = 0;
      for (const selection of Array.from(this.checkBoxesByDayType.get(dt.code))) {
        if (selection.value){
          nbSelected ++;
        }
      }
      if (nbSelected >= nbPlanned){
        this.alertService.error(this.translate.instant('TooManyScheduleForThisDay',{nbPlanned: nbPlanned}),101);
        res = false;
      }else{
        this.alertService.clear();
        res = true;
        this.checkBoxesByEmployeeByDayType.get(bean.employee.id).get(dt.code).value = res;
      }
    }
    return res;
  }

  /**
   * Retrieved the refDate for the 'Monday'
   */
  private _retrieveDateFromDayType(dt: DayType): Date{
    let res = null;
    for (const refDt of this.weeklyWorkShift.refDates){
      if (dt === DayType.retrieveFromDate(refDt)){
        res = refDt;
        break;
      }
    }
    return res;
  }


  onMissingWorkshift(){
    this.activeModal.close(ModalResult.OTHER)
  }


  onValidate() {

    let res = new Array<EmployeeSchedule>();
    for (const bean of this.allCheckboxes ){
      if (true === bean.value){
        const es = new EmployeeSchedule();
        es.employee = bean.data.employee;
        es.employeeId = bean.data.employee.id;
        es.refDate  = this._retrieveDateFromDayType(bean.dayType);
        es.wage = bean.data.wage;

        const planningDetails = this.weeklyWorkShift.getPlanningDetails(bean.dayType);
        if (planningDetails.length>0){
          const pd = planningDetails[0];
          console.log('Copying Planning details from ',pd);
          es.copyMealsBreaksAndTasks(pd);
          console.log('Planning details copied to ',es);
          // pd.addMealsAndBreaks(es);
        }
        if (planningDetails.length>1){
          console.log('More than 1 planning. Cant retrieve Meals Information');
        }
        res.push(es);
      }
    }
    // for (const id of Array.from(this.all.keys())) {
    //   if (this.selectedRowIndex.get(id)) {
    //       res = this.employeeForSchedulings[id];
    //   }
    // }

    if (res) {
      this.alertService.clear();
      // console.log('Nb Selected EmployeSchedule: ' + res.length);
      this.activeModal.close(res);
    } else {
      // console.log('No Employee Selected');
      this.message = {type: 'error', text: this.translate.instant('NoEmployeeSelected')};
    }

  }

  onCancel() {
    this.activeModal.close(null);
  }


  private _sortByName = '' ;
  public toggleSortByName(){
    let reverse = - 1;
    if ('DSC' === this._sortByName){
      reverse = 1;
      this._sortByName = 'ASC';
    }else{
      this._sortByName = 'DSC';
    }
    this.employeeForSchedulings.sort((e1,e2)=>{
      let res = e1.employee.lname.localeCompare(e2.employee.lname);
      if (res==0){
        res = e1.employee.fname.localeCompare(e2.employee.fname);
      }
      return reverse*res;
    });
  }

  private _sortBySeniority='';

  toggleSortBySeniority(){
    let reverse = - 1;
    if ('DSC' === this._sortBySeniority){
      reverse = 1;
      this._sortBySeniority = 'ASC';
    }else{
      this._sortBySeniority = 'DSC';
    }
    this.employeeForSchedulings.sort((e1,e2)=>{
      let res = 0;
      if (e1.seniority>e2.seniority){
        res = 1;
      }
      if (e1.seniority<e2.seniority){
        res = -1;
      }
      return reverse*res;
    });
  }

  private _sortByWage = '';

  toggleSortByWage(){
    let reverse = - 1;
    if ('DSC' === this._sortByWage){
      reverse=1;
      this._sortByWage = 'ASC';
    }else{
      this._sortByWage = 'DSC';
    }

    this.employeeForSchedulings.sort((e1,e2)=>{
      let res = 0;
      if (e1.wage>e2.wage){
        res = 1;
      }
      if (e1.wage<e2.wage){
        res = -1;
      }
      return reverse*res;
    });
  }


}

/**
 * Represents a checkbox.
 */
export class EmployeeScheduleSelection {
  employeeId: string;
  dayType: DayType;
  value = false;
  data: EmployeeForScheduling;

}

